import { processAssignments, getPatrolLocation } from "../utils/utils.js";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent'; import Box from "@mui/material/Box";
import MapFilters from "../components/map/MapFilter.js";
import { SearchBox } from '@mapbox/search-js-react';
import { MAPBOX_API_KEY } from "../utils/config.js";
import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
// eslint-disable-next-line import/no-unresolved
import Map from 'react-map-gl/mapbox';
import DeckGL from '@deck.gl/react';
import PinLayer from '../components/map/PinLayer.js';
import Assignments from '../components/map/Assignments.js';
import { assignPatrolAsync } from "../redux/slices/tasksSlice.js";
import { setNotification } from "../redux/slices/notificationSlice.js";
import { Alert } from "@mui/material";

const MapPage = ({entityId, entityType, setSelectedEntityId, setModalType, setShowModal}) => {
  
  const dispatch = useDispatch();
  const [assignments, setAssignments] = useState([]);
  const [visibleLines, setVisibleLines] = useState({task: new Set(), patrol: new Set()});
  const [loading, setLoading] = useState(true);
  const [assigPatrolId, setAssigPatrolId] = useState(null);
  const [assigTaskId, setAssigTaskId] = useState(null);
  const [filters, setFilters] = useState({
    tasks: {
      requiresIntervention: undefined,
      isHomestart: undefined,
      vehicleRegistrationNumber: undefined,
      statusId: [], //14
    },
    patrols: {
      status: [], //8
      fullName: undefined,
    },
    mixed: {
      resource: [],
    }
  });

  const [viewState, setViewState] = useState({
    longitude: -0.1278,
    latitude: 51.5074,
    zoom: 12,
    pitch: 0,
    bearing: 0,
  });

  const tasks = useSelector((state) => state.tasks.filteredTasks);
  const patrols = useSelector((state) => state.patrols.filteredPatrols);
  const allTasks = useSelector((state) => state.tasks.allTasks);
  const allPatrols = useSelector((state) => state.patrols.allPatrols);
  const taskStatuses = useSelector((state) => state.constants.data.taskStatuses);
  const resourceStatuses = useSelector((state) => state.constants.data.resourceStatuses);
  const assignmentsLayer = Assignments({assignments});

  const toggleLine = (id, type) => {
    
    setVisibleLines(prev => {

      let entity;
      let dupe = false;
      const updated = {
        task: new Set(prev.task),
        patrol: new Set(prev.patrol),
      };

      if(type == 'PATROL') {
        entity = patrols.find(p => p.id == id);
        for(const t of entity.assignedTasks) {
          if(updated.task.has(t)) {
            updated.task.delete(t);
            return updated;
          }
        }
      }
      if(type == 'TASK') {
        entity = tasks.find(p => p.id == id);
        if(updated.patrol.has(entity.assignedPatrolId)) {
          updated.patrol.delete(entity.assignedPatrolId);
          return updated;
        }
      }

      if(updated[type.toLowerCase()].has(id)) {
        updated[type.toLowerCase()].delete(id);
      } else {

        //cleanup
        for(const item of updated[type.toLowerCase()]){
          if(item != id) {
            updated[type.toLowerCase()].delete(item);
          }
        }
       
        if(type == 'PATROL') {
          //cleanup other entity type
          updated['task'] = new Set();
        }
        if(type == 'TASK') {
          //cleanup other entity type
          updated['patrol'] = new Set();
        }

        //check for duplicated lines that could be there because the connected entity was clicked first
        if(type == 'PATROL') {
          for(const p of entity.assignedTasks) {
            if(updated.task.has(p)) {
              //hide line when clicking the other side of the assignment
              updated.task.delete(p);
              dupe = true;
            }
          }
        }

        if(type == 'TASK') {
          if(updated.patrol.has(entity.assignedPatrolId)) {
            //hide line when clicking the other side of the assignments
            updated.patrol.delete(entity.assignedPatrolId);
            dupe = true;
          }
        }

        !dupe && updated[type.toLowerCase()].add(id, entity);
      }
      return updated;
    });
  }

  useEffect(() => {
      if(assigTaskId && assigPatrolId) {
          handleAssignment(assigTaskId, assigPatrolId);
      }
  }, [assigTaskId, assigPatrolId]);

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
 
    document.addEventListener('contextmenu', handleContextMenu);
 
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);
  
  useEffect(() => {
    if(tasks && tasks.length > 0 && patrols && patrols.length > 0) {
      setAssignments(processAssignments(patrols, tasks, visibleLines));
    }
    if(patrols && patrols.length > 0) {
      setLoading(false);
    }
  }, [tasks, patrols, visibleLines]);

  useEffect(() => {
    if(allTasks.length && allPatrols.length) {
      dispatch({
        type: 'tasks/filterTasks', 
        payload: filters
      });
  
      dispatch({
        type: 'patrols/filterPatrols', 
        payload: filters
      });
    }

  }, [allTasks, allPatrols]);
  
  useEffect(() => {
    if(entityType == 'TASK') {
      const task = tasks.find(t => t.id == entityId);
      if(task && task.location && task.location?.lat) {
        setViewState(prev => ({ ...prev, longitude: task.location.lng, latitude: task.location.lat, zoom: 14 }));
      }
    }

    if(entityType == 'PATROL' && patrols.length) {
      const patrol = patrols.find(p => p.id == entityId);
      var location;
      if(patrol) {
        location = getPatrolLocation(patrol);
      }
      if(patrol && location) {
        setViewState(prev => ({ ...prev, longitude: location.lng, latitude: location.lat, zoom: 14 }));
      }
    }
  }, [entityId, patrols]);

  useEffect(() => {
  
    dispatch({
      type: 'tasks/filterTasks', 
      payload: filters
    });

    dispatch({
      type: 'patrols/filterPatrols', 
      payload: filters
    });

  }, [filters]);

  const handleAssignment = async (assigTaskId, assigPatrolId) => {
    try{
      const assignResp = await dispatch(assignPatrolAsync({
        id: assigTaskId, patrolId: assigPatrolId
      })).unwrap();

      if(assignResp.status == 200 || assignResp.status == 204) {
        dispatch(
          setNotification({ severity: 'success', message: 'Patrol assigned.' })
        );
      }
    } catch(error){
      dispatch(
        setNotification({ severity: 'error', message: 'Patrol assignment error: ' + error.message })
      );
    }
  }
  
  const completedStatusId = taskStatuses.find(t => t.code == 'COMP')?.id;
  const offdPatrolStatusId = resourceStatuses.find(t => t.code == 'OFFD')?.id;
  
  const tasksLayer = PinLayer({viewState, type: 'TASK', items: tasks.filter(t => t.statusId != completedStatusId), setSelectedEntityId, setModalType, setShowModal, toggleLine, entityId, entityType, setAssigPatrolId, setAssigTaskId});
  const patrolsLayer = PinLayer({viewState, type: 'PATROL', items: patrols.filter(p => p.status.id != offdPatrolStatusId), setSelectedEntityId, setModalType, setShowModal, toggleLine, entityId, entityType, setAssigPatrolId, setAssigTaskId});

  if (loading) {
    return <div>Loading data...</div>;
  }
  return (
    <Card
      variant="outlined"
      sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}
    >
        <CardContent>
          <Box sx={{mt: 2, mb: 4}}>
            <Alert severity="info" sx={{backgroundColor: '#e5f6fd'}} >
            <strong>Click</strong> a pin to see existing assignments.<br/>
              <strong>Ctrl-click</strong> a pin to see Task/Patrol details.
            </Alert>
          </Box>
          <Box sx={{mb: 2, mt: 2}}>
            <MapFilters filters={filters} setFilters={setFilters} />
          </Box>
          <Box style={{ height: "700px", width: "100%", position:"relative"}}>
            
            <Box
              sx={{
                display: "flex",
                border: '1px solid',
                borderColor: 'divider',
                  borderRadius: '6px 6px 0 0',
                  bgcolor: 'background.paper',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: { xs: 1, sm: 2},
                  padding: { xs: 1, sm: 2 }
                }}

              >
                <Box sx={{ pointerEvents: 'auto', position: 'absolute', top: 30, left: 10, zIndex: 10, width: 300, background: 'white', p: 1, borderRadius: 1, boxShadow: 3 }}>
                  <SearchBox
                    accessToken={MAPBOX_API_KEY}
                    onRetrieve={(res) => {
                      const [lng, lat] = res.features[0].geometry.coordinates;
                      setViewState(prev => ({ ...prev, longitude: lng, latitude: lat, zoom: 14 }));
                    }}
                  />
                  
                </Box>
                <Box>
                  <DeckGL
                    initialViewState={viewState}
                    //viewState={viewState}
                     onViewStateChange={({viewState}) => {
                       setViewState(prev => ({...prev, ...viewState}));
                     }}
                    controller
                    layers={[[...patrolsLayer], [...tasksLayer], assignmentsLayer]}
                  >
                    <Map
                      mapboxAccessToken={MAPBOX_API_KEY}
                      mapStyle="mapbox://styles/mapbox/streets-v11"
                    />
                  </DeckGL>
                </Box>
              </Box>
          </Box>
              
        </CardContent>
      </Card>
  );
  
};

export default MapPage;
